import { getErrorMessage } from "../locales/translationUtils";
import api from "./api";

export const downloadContent = async (id: number) => {
    try {
        const url: string = `/Content/download`;

        return await api.get(`${url}/${id}`, {
            headers: {
                Accept: '*/*'
            },
            responseType: 'blob'
        });
    } catch (error) {
        console.error(getErrorMessage("downloadContentError", {}));
        throw error;
    }
};
